import Component from '../core/Component'
import { toggleClass } from '../utils/dom'
import { queries } from '../core/config'
import enquire from 'enquire.js'

const STATES = {
    ACTIVE: 'is-active'
}

const defaults = {
    media: null
}

export default class ScrollSlider extends Component {
    constructor(element, defaults) {
        super(element)

        this.ref = {
            buttons: [],
            items: []
        }

        this.current = 0
        this.duration = 4000
        this.timer = null

        this.enquireHandler = null

        if (this.options.media) {
            this.options.media = queries[this.options.media] || this.options.media
            this.enquireHandler = {
                match: this.attach,
                unmatch: this.detach
            }
        }
    }

    prepare() {
        if (this.options.media) {
            enquire.register(this.options.media, this.enquireHandler)
        } else {
            this.attach()
        }
    }

    destroy() {
        if (this.options.media) {
            enquire.unregister(this.options.media, this.enquireHandler)
        }
        this.detach()
    }

    attach = () => {
        this.ref.buttons.forEach(element => element.addEventListener('click', this.handleButtonClick))
        this.show(this.ref.items[0].id)
        this.start()
    }

    detach = () => {
        this.stop()
        this.current = 0
        this.ref.items.forEach(element => element.classList.remove(STATES.ACTIVE))
        this.ref.buttons.forEach(element => element.removeEventListener('click', this.handleButtonClick))
    }

    handleButtonClick = event => {
        event.preventDefault()
        this.stop()
        this.show(event.currentTarget.getAttribute('href').replace('#', ''))
        this.start()
    }

    show(id) {
        const target = document.getElementById(id)

        if (!target) {
            return
        }

        this.current = this.ref.items.indexOf(target)
        this.ref.buttons.forEach((element, index) => toggleClass(element, STATES.ACTIVE, this.current === index))

        this.ref.items.forEach((element, index) => toggleClass(element, STATES.ACTIVE, this.current === index))
    }

    start() {
        clearInterval(this.timer)
        this.timer = setInterval(this.next, this.duration)
    }

    stop() {
        clearInterval(this.timer)
    }

    next = () => {
        const next = (this.current + 1) % this.ref.items.length
        const id = this.ref.buttons[next].getAttribute('href').replace('#', '')
        this.show(id)
    }

}
